import React from 'react';
import PropTypes from 'prop-types';

import Tab from 'react/containers/layout/tabs/Tab';
import TaskSchedulerContainer from 'react/components/TaskScheduler';

class TaskScheduler extends Tab {

  static propTypes = {
    onClose: PropTypes.func,
    active: PropTypes.bool,
  }

  static tabName = 'TaskScheduler.title'

  activeClassName = 'is-active'

  render() {
    const { active } = this.props;
    const className = `gmTabs__panel ${(active) ? this.activeClassName : ''}`;

    return (
      <TaskSchedulerContainer className={className}/>
    );
  }
}

export default TaskScheduler;
